import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TituloAdmin from '@components/TituloAdmin';
import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';
import { colors } from '@styles/colors';

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div style={cajaPrincipalStyle}>
      <TituloAdmin titulo="Bienvenido a la Administración" />
      
      <div style={{
        ...cajaContenedorAdminStyle,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh'
      }}>
        <h2 style={{ 
          fontFamily: 'Inter', 
          color: colors.primaryText,
          marginBottom: '2rem'
        }}>
          Panel de Control Administrativo
        </h2>
        
        <div style={{
          padding: '2rem',
          backgroundColor: colors.gray150,
          borderRadius: '12px',
          textAlign: 'center',
          maxWidth: '600px'
        }}>
          <p style={{ fontFamily: 'Inter', color: colors.gray700, fontSize: '1.1rem' }}>
            Selecciona una opción del menú lateral para comenzar a gestionar la plataforma.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
